<div class="dropdown-container" tabindex="0" [class.is-open]="isOpen" [class.is-disabled]="disabled">
  <div class="dropdown-box" (click)="toggleDropdown($event)" [attr.aria-disabled]="disabled">
    <span class="dropdown-label" [class.placeholder]="getTotalGroupsCount() === 0 && getTotalInstrumentsCount() === 0">{{ getDropdownLabel() }}</span>
  </div>
  <button type="button" (click)="toggleDropdown($event)" [disabled]="disabled" data-testid="ic-groupdropdown-toggle-button" class="dropdown-button"
    aria-label="Toggle instrument groups dropdown">
    <mat-icon>{{ isOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
  </button>
</div>

<div *ngIf="isOpen" class="dropdown-content">
  <div class="dropdown-content-header">
    <div class="title">Instrument groups</div>
    <div class="subtitle">Expand a group to add individual instruments, or use Add group to include all available instruments.</div>
    <div class="filters-row">
      <mat-slide-toggle color="primary" [(ngModel)]="showAddedInstruments" data-testid="ic-groupdropdown-showadded-toggle">
        Show already added instruments
      </mat-slide-toggle>
      <mat-slide-toggle color="primary" [(ngModel)]="showOnlyReadyInstruments" data-testid="ic-groupdropdown-showonlyready-toggle">
        Only instruments with LUT + FC
      </mat-slide-toggle>
    </div>
    <div class="search-row" (click)="$event.stopPropagation()">
      <mat-form-field appearance="outline" class="quick-search-field" subscriptSizing="dynamic">
        <mat-label>Quick search</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput type="text" [(ngModel)]="searchTerm" placeholder="Filter groups or instruments"
          data-testid="ic-groupdropdown-search-input" aria-label="Search groups or instruments" />
        <button *ngIf="searchTerm" type="button" matSuffix mat-icon-button (click)="clearSearch($event)" aria-label="Clear search">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </div>

  <ng-container *ngFor="let group of groups">
    <ng-container *ngIf="shouldShowGroup(group)">
      <div class="group">
        <div class="group-header" *ngIf="group[groupItemsProp].length > 0">
          <button type="button" color="primary" class="expand-button"
            [attr.data-testid]="(group.expanded ? 'ic-groupdropdown-collapse-button-' : 'ic-groupdropdown-expand-button-') + group[groupDisplayProp]"
            (click)="toggleGroup($event, group)" mat-icon-button [disabled]="disabled">
            <mat-icon>{{ group.expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
          </button>

          <mat-icon class="group-icon">folder</mat-icon>
          <span class="label">{{ group[groupDisplayProp] }}</span>
          <span class="available-count">{{ getAvailableItemsCount(group) }}</span>
          <span class="spacer"></span>

          <button *ngIf="!hideGroupSelection" type="button" color="primary" mat-stroked-button
            [attr.data-testid]="'ic-groupdropdown-selectgroup-button-' + group[groupDisplayProp]" (click)="selectGroup($event, group)"
            class="add-group-button" [disabled]="disabled">
            <mat-icon>add</mat-icon>
            Add group
          </button>

          <button *ngIf="!hideGroupSelection && showAddedInstruments && getSelectedItemsCount(group) > 0" type="button" mat-stroked-button
            [attr.data-testid]="'ic-groupdropdown-removegroup-button-' + group[groupDisplayProp]" (click)="removeGroup($event, group)"
            class="remove-group-button" [disabled]="disabled">
            <mat-icon>remove</mat-icon>
            Remove group
          </button>
        </div>

        <div *ngIf="group.expanded" class="instruments-list">
          <ng-container *ngFor="let item of group[groupItemsProp]">
            <div *ngIf="shouldShowItem(item)" class="item-header" [class.item-added]="isAlreadySelected(item)">
              <mat-icon class="item-icon">memory</mat-icon>
              <span class="label">{{ item[itemDisplayProp] }}</span>
              <div class="status-tags">
                <span class="status-tag" [class.available]="item.hasLUTFile" [class.missing]="!item.hasLUTFile"
                  [matTooltip]="item.hasLUTFile ? 'LUT file available' : 'LUT file not found'">
                  LUT
                </span>
                <span class="status-tag" [class.available]="item.hasFactoryCalibrationFile" [class.missing]="!item.hasFactoryCalibrationFile"
                  [matTooltip]="item.hasFactoryCalibrationFile ? 'Factory Calibration file available' : 'Factory Calibration file not found'">
                  FC
                </span>
              </div>
              <span class="spacer"></span>
              <ng-container *ngIf="!isAlreadySelected(item); else addedIndicator">
                <button type="button" color="primary" mat-icon-button [attr.data-testid]="'ic-groupdropdown-selectitem-button-' + item[itemDisplayProp]"
                  (click)="selectItem($event, item)" [disabled]="disabled" class="add-item-button" matTooltip="Add instrument">
                  <mat-icon>add_circle</mat-icon>
                </button>
              </ng-container>
              <ng-template #addedIndicator>
                <div class="added-actions">
                  <span class="added-tag">Added</span>
                  <button type="button" mat-icon-button class="remove-item-button"
                    [attr.data-testid]="'ic-groupdropdown-removeitem-button-' + item[itemDisplayProp]"
                    (click)="removeItem($event, item)" [disabled]="disabled" matTooltip="Remove instrument">
                    <mat-icon>remove_circle</mat-icon>
                  </button>
                </div>
              </ng-template>
            </div>
          </ng-container>

          <div *ngIf="getEmptyGroupMessage(group)" class="empty-group">
            {{ getEmptyGroupMessage(group) }}
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <div class="no-results" *ngIf="!hasVisibleGroups()">
    No groups or instruments match your search.
  </div>
</div>